import { useForm, zodResolver } from '@mantine/form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PageContainer,
  PageFooter,
  PageHeader,
  SimpleStepDots,
  StepProps,
  DataProcessingAgreement,
  DataProtectionGuidelines,
  TermsAndConditions,
} from '../../../shared_components';
import { Checkbox, Flex, Space, Stack, TextInput, Text } from '@mantine/core';
import EastIcon from '@mui/icons-material/East';
import classes from '../../../app.module.css';
import {
  emailAndConsents,
  EmailAndConsents,
  useUserDataStore,
} from '../../../shared_stores';

export const StepEmail = ({ forward, back, step = 0, max = 0 }: StepProps) => {
  const { t } = useTranslation(['registration', 'common']);
  const userDataStore = useUserDataStore();
  const [isValid, setIsValid] = useState(
    userDataStore.emailAndConsents !== undefined,
  );
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);
  const [showDataProtection, setShowDataProtection] = useState(false);
  const [showDataProcessing, setShowDataProcessing] = useState(false);
  const form = useForm<EmailAndConsents>({
    initialValues: userDataStore.emailAndConsents,
    validateInputOnBlur: true,
    validate: zodResolver(emailAndConsents),
  });

  const handleChange = () => {
    const values = form.getValues();
    if (form.isDirty()) {
      userDataStore.setStoreDirty(true);
    }
    if (values.gtcConsent) {
      setIsValid(form.isValid());
    } else {
      setIsValid(false);
    }
  };

  const handleSubmit = () => {
    userDataStore.setEmailAndConsents(form.getValues());
    forward();
  };

  return (
    <>
      {showDataProcessing && (
        <DataProcessingAgreement onClose={() => setShowDataProcessing(false)} />
      )}

      {showDataProtection && (
        <DataProtectionGuidelines
          onClose={() => setShowDataProtection(false)}
        />
      )}

      {showTermsAndConditions && (
        <TermsAndConditions onClose={() => setShowTermsAndConditions(false)} />
      )}
      <PageContainer>
        <form
          onChange={handleChange}
          onSubmit={form.onSubmit(handleSubmit, console.log)}
        >
          {!showDataProcessing &&
            !showTermsAndConditions &&
            !showDataProtection && (
              <Flex direction={'column'} justify={'space-between'} h={'100%'}>
                <Stack classNames={{ root: classes.footerPadding }}>
                  <PageHeader
                    title={t('email_title')}
                    message={t('email_message')}
                    topElement={
                      <SimpleStepDots step={step} max={max} text={false} />
                    }
                  />
                  <TextInput
                    label={t('email')}
                    placeholder={t('email')}
                    key={form.key('email')}
                    {...form.getInputProps('email')}
                  />
                  <Space h={'var(--mantine-spacing-xs)'} />
                  <Checkbox
                    checked={form.getValues().gtcConsent}
                    label={
                      <Text>
                        {t('consent_end_user_agreement_1')}{' '}
                        <a
                          href={'/'}
                          onClick={(e) => {
                            e.preventDefault();
                            setShowTermsAndConditions(true);
                          }}
                        >
                          {t('end_user_agreement')}
                        </a>{' '}
                        &{' '}
                        <a
                          href={'/'}
                          onClick={(e) => {
                            e.preventDefault();
                            setShowDataProtection(true);
                          }}
                        >
                          {t('data_protection_guidelines')}
                        </a>{' '}
                        {t('consent_end_user_agreement_2')}
                      </Text>
                    }
                    {...form.getInputProps('gtcConsent')}
                  />
                  {/* TODO CBYN-186: VERSION 2 Feature - newsletter */}
                  {/* <Checkbox
                    checked={form.getValues().newsletterConsent}
                    label={t('checkbox_newsletter')}
                    {...form.getInputProps('newsletterConsent')}
                  /> */}
                </Stack>
                <PageFooter
                  leftOnClick={back}
                  buttonText={t('continue')}
                  buttonIcon={<EastIcon />}
                  submitButton={true}
                  disabled={!isValid}
                />
              </Flex>
            )}
        </form>
      </PageContainer>
    </>
  );
};
